import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { Button, Card, CardContent, CardHeader, Divider, Stack } from '@mui/material';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { helpRoutes } from '../../routes';
import { useGetAllArticles, useGetAllCategories } from '../../sic-lib/api/hooks/useHelp';
import Loader from '../Shared/Loader';

export default function HelpMain() {
    const history = useHistory();
    const { data: categoriesData, isLoading } = useGetAllCategories();

    const { data: articlesData, isLoading: articlesLoading } = useGetAllArticles();

    const importantCategory = React.useMemo(() => {
        return categoriesData?.filter(category => category.important) || [];
    }, [categoriesData]);

    const importantArticles = React.useMemo(() => {
        return articlesData?.filter(article => article.isSticky) || [];
    }, [articlesData]);

    const handleClick = (isCategory: boolean, Id: number) => {
        if (isCategory) {
            history.push(helpRoutes.setCategory(Id));
        } else {
            history.push(helpRoutes.setArticle(Id));
        }
    };

    return (
        <>
            <Loader isLoading={isLoading}>
                <Card>
                    <CardHeader title="Knowledge Library" />
                    <Divider />
                    <CardContent>
                        <Stack flexDirection="row" alignItems="center" justifyContent="center">
                            {importantCategory.map(category => {
                                return (
                                    <Button
                                        key={category.categoryId}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<LibraryBooksIcon />}
                                        sx={{ marginRight: 2 }}
                                        onClick={() => handleClick(true, category.categoryId)}
                                    >
                                        {category.categoryName}
                                    </Button>
                                );
                            })}
                        </Stack>
                    </CardContent>
                </Card>
            </Loader>
            <Loader isLoading={articlesLoading}>
                <Card>
                    <CardHeader title="Important Articles" />
                    <Divider />
                    <CardContent>
                        <Stack
                            flexDirection="column"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                        >
                            {importantArticles.map(article => {
                                return (
                                    <Button
                                        key={article.articleId}
                                        color="primary"
                                        onClick={() => handleClick(false, article.articleId)}
                                    >
                                        {article.title}
                                    </Button>
                                );
                            })}
                        </Stack>
                    </CardContent>
                </Card>
            </Loader>
        </>
    );
}
